export default {
  production: {
    clientId: '0oa2ul8rlePlNldiQ5d7',
    issuer: 'https://login.guesty.com/oauth2/aus2jlqfuwAsNNp3D5d7',
    backofficeIssuer:
      'https://admin-login.guesty.com/oauth2/ausol0oegkyYMoyBk5d7',
    googleIDPId: '0oaawc7ghqmY4AWqV5d7',
  },
  trial: {
    clientId: '0oa2ul8rlePlNldiQ5d7',
    issuer: 'https://login.guesty.com/oauth2/aus2jlqfuwAsNNp3D5d7',
  },
  staging0: {
    clientId: '0oa5uurgz2gTtijhN5d7',
    issuer: 'https://login-staging0.guesty.com/oauth2/aus5uux0nrEFk69cb5d7',
    googleIDPId: '0oal0gj142eqAyqiZ5d7',
  },
  staging1: {
    clientId: '0oat6eq8siIh0mxc1697',
    issuer: 'https://login-staging1.guesty.com/oauth2/aust6epmaacIlV2JY697',
  },
  staging2: {
    clientId: '0oat7lyjklI3r2MrO697',
    issuer: 'https://login-staging2.guesty.com/oauth2/aust7lvsvoTZaowVt697',
  },
  staging3: {
    clientId: '0oat8ua22lWqjU9Cf697',
    issuer: 'https://login-staging3.guesty.com/oauth2/aust8u9cl79zYpYoA697',
  },
  staging4: {
    clientId: '0oat9w6co7WzuhHax697',
    issuer: 'https://login-staging4.guesty.com/oauth2/aust9w07iloSOtIzM697',
  },
  staging5: {
    clientId: '0oatenola3JP5HbHZ697',
    issuer: 'https://login-staging5.guesty.com/oauth2/austenhndvsIYfxXU697',
  },
  staging6: {
    clientId: '0oat9w00dpFVFsNL3697',
    issuer: 'https://login-staging6.guesty.com/oauth2/aust9w2514zQfa4eE697',
  },
  staging7: {
    clientId: '0oat9w1u6y5Zd4gcV697',
    issuer: 'https://login-staging7.guesty.com/oauth2/aust9w3glwL8Q5LOd697',
  },
  staging8: {
    clientId: '0oatbuoobj60n6Zpw697',
    issuer: 'https://login-staging8.guesty.com/oauth2/austbujlu0sXSAjZL697',
  },
  staging9: {
    clientId: '0oatbulqvbh0MPa7r697',
    issuer: 'https://login-staging9.guesty.com/oauth2/austbukis88C2YjbF697',
  },
  staging10: {
    clientId: '0oasox9dwm8CDSVaA697',
    issuer: 'https://login-staging10.guesty.com/oauth2/aussoxd8ucxrJcKN0697',
  },
  staging11: {
    clientId: '0oatbulqxgJExVQsK697',
    issuer: 'https://login-staging11.guesty.com/oauth2/austbup9c8WWyf2FC697',
  },
  staging12: {
    clientId: '0oatbunhfoCtuPRUQ697',
    issuer: 'https://login-staging12.guesty.com/oauth2/austbup8emxIijBFp697',
  },
  staging13: {
    clientId: '0oa3p7juvrddC0bhi5d7',
    issuer: 'https://login-staging13.guesty.com/oauth2/aus3p7iaksbjL4C215d7',
    backofficeIssuer:
      'https://admin-login-staging13.guesty.com/oauth2/ausq8h32jmQtUmOoy5d7',
    googleIDPId: '0oal0gj142eqAyqiZ5d7',
  },
  staging14: {
    clientId: '0oatbunorddhz4UNO697',
    issuer: 'https://login-staging14.guesty.com/oauth2/austbulsftq2o3LXW697',
  },
  staging15: {
    clientId: '0oateny19h1qUDpbr697',
    issuer: 'https://login-staging15.guesty.com/oauth2/austenvt34n98s14V697',
  },
  staging16: {
    clientId: '0oatenxtg1OsSzWch697',
    issuer: 'https://login-staging16.guesty.com/oauth2/austenwg2yrGQOlWn697',
  },
  staging17: {
    clientId: '0oatenvpaz7XRdQzc697',
    issuer: 'https://login-staging17.guesty.com/oauth2/austenhs15UM0zL8C697',
  },
  staging18: {
    clientId: '0oateo598gZXppY1Q697',
    issuer: 'https://login-staging18.guesty.com/oauth2/austenvt51fnQZsbr697',
  },
  staging19: {
    clientId: '0oatenhs2xgN1C0HI697',
    issuer: 'https://login-staging19.guesty.com/oauth2/austeni7k868XrQ4m697',
  },
  staging20: {
    clientId: '0oatenlsdnO4h9Ifh697',
    issuer: 'https://login-staging20.guesty.com/oauth2/austenxe2rbNAIG0x697',
  },
  staging21: {
    clientId: '0oa137i32padm87Gt698',
    issuer: 'https://login-staging21.guesty.com/oauth2/aus137hx92hht9tqT698',
  },
  sandbox: {
    clientId: '0oaggw5it1YBHTmwW696',
    issuer: 'https://login-sandbox.guesty.com/oauth2/ausggvw8u7aMPqDpA696',
    backofficeIssuer:
      'https://admin-login.guesty.com/oauth2/ausol0oegkyYMoyBk5d7',
  },
};
